/**
 * pow_returning — a non-httpOnly, non-sensitive rendering hint only.
 *
 * It carries no identity and grants no access; the server still validates the real
 * httpOnly session cookie on every request. It exists purely so the boot sequence can
 * decide, before any network call, whether to render the public landing page or go
 * through the authenticated-app warm-up gate. See
 * docs/decisions/2026-08-04-pow-returning-flag.md.
 */

const FLAG_NAME = 'pow_returning'
const MAX_AGE_SECONDS = 60 * 60 * 24 * 365

export function hasReturningVisitorFlag(): boolean {
  return document.cookie.split('; ').some((entry) => entry === `${FLAG_NAME}=1`)
}

export function setReturningVisitorFlag(): void {
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${FLAG_NAME}=1; path=/; max-age=${MAX_AGE_SECONDS}; SameSite=Lax${secure}`
}

export function clearReturningVisitorFlag(): void {
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${FLAG_NAME}=1; path=/; max-age=0; SameSite=Lax${secure}`
}
